enum ActionTypes {
  SET_FILTERS = '@player-report/SET_FILTERS',
  RESET_ALL = '@player-report/RESET_ALL',

  GET_PLAYER_REPORT = '@player-report/GET_PLAYER_REPORT',
  GET_PLAYER_REPORT_SUBSCRIBER = '@player-report/GET_PLAYER_REPORT_SUBSCRIBER',
}

export default ActionTypes
